import React from 'react';
import { Trans } from '@lingui/macro';
import { getSearchEntityLink } from 'app/domains/global-search/utils/getSearchEntityLink';
import { useArrowNavigation } from 'shared/domains/common-ui';
import { Date } from './Date';
import { Match } from './Match';
import { Type } from './Type';
import { useUniversalSearch } from '../../useUniversalSearch';
import { Container, Head, ColumnHead, StyledLink } from './styled';
export function Desktop() {
    var _a;
    const { data, closeSearchPopup } = useUniversalSearch();
    const { results = [] } = (_a = data === null || data === void 0 ? void 0 : data.search) !== null && _a !== void 0 ? _a : {};
    const arrowNavigation = useArrowNavigation();
    return (<Container>
      <Head>
        <ColumnHead id="search-column-result" data-name>
          <Trans>Results</Trans>
        </ColumnHead>
        <ColumnHead id="search-column-type" data-type>
          <Trans>Type</Trans>
        </ColumnHead>
        <ColumnHead id="search-column-date" data-date>
          <Trans>Added</Trans>
        </ColumnHead>
      </Head>

      {results.map(item => {
            const { id, entityId, name, createdAt, type, meta } = item;
            return (<StyledLink key={id} to={getSearchEntityLink(type, entityId)} onClick={closeSearchPopup} {...arrowNavigation}>
            <Match aria-describedby="search-dropdown-result" name={name} type={type} highlight={meta.highlight}/>
            <Type aria-describedby="search-column-type" type={type}/>
            <Date aria-describedby="search-column-date" createdAt={createdAt}/>
          </StyledLink>);
        })}
    </Container>);
}
